import { oauth } from '../OAuth';
import { DisclaimerConfiguration } from '../types';

import { restCall } from './api';

const dispatchCentersEndpoint = process.env.REACT_APP_DISPATCHCENTERS_ENDPOINT;
const disclaimerConfigurationsEndpoint = process.env.REACT_APP_DISCLAIMER_CONFIG_ENDPOINT;
const disclaimerConfigurationForDispatchCenterEndpoint = process.env.REACT_APP_DISCLAIMER_CONFIG_DISPATCH_CENTER;
const resetConfirmationGivenEndpoint = process.env.REACT_APP_DISCLAIMER_RESET;

interface DisclaimerConfigurationResponse extends DisclaimerConfiguration {
    id: number;
    _links: any;
}

export const getDisclaimerConfigurationForDispatchCenter = async addOnId => {
    const dispatchCenterConfigURL = `${disclaimerConfigurationForDispatchCenterEndpoint}/${addOnId}`;

    const res: DisclaimerConfigurationResponse = await restCall(dispatchCenterConfigURL, {
        withCredentials: true,
        headers: {
            Authorization: `Bearer ${oauth.bearerToken}`,
            'Content-Type': 'application/json',
        },
        method: 'GET',
    });

    return res;
}

interface DisclaimerConfigurationPostData extends DisclaimerConfiguration {
    addOnId: number;
}

export const updateDisclaimerConfiguration = async ({
    addOnId,
    disclaimerTextDispatcher = "",
    disclaimerTextBystander = "",
    confirmationText = "",
    enabledForDispatcher,
    enabledForBystander,
    confirmationEnabledForDispatcher,
}: DisclaimerConfigurationPostData) => {
    const centerRef = `${dispatchCentersEndpoint}/${addOnId}`;
    let method = 'PATCH';
    let url = disclaimerConfigurationsEndpoint;

    // check if there is already a disclaimer configuration for this dispatch center
    // if not (e.g. 404, 403) then create a new one (POST)
    const response = await getDisclaimerConfigurationForDispatchCenter(addOnId);
    // if there is no response, then create a new disclaimer configuration
    if (!response) method = 'POST';
    // add the disclaimer configuration id to the url if it exists
    if (response) url += `/${response.id}`;

    const data = {
        disclaimerTextDispatcher,
        disclaimerTextBystander,
        confirmationText,
        enabledForBystander,
        enabledForDispatcher,
        confirmationEnabledForDispatcher,
        "dispatchCenter": centerRef
    }

    const mergedParams = {
        body: JSON.stringify(data),
        headers: {
            Authorization: `Bearer ${oauth.bearerToken}`,
            'Content-Type': 'application/json',
        },
        method,
        withCredentials: true,
    };

    return await restCall(url, mergedParams) as DisclaimerConfiguration;
};

export const resetGivenConfirmationsForDispatchCenter = async (id: number) => {
    await restCall(`${resetConfirmationGivenEndpoint}?dispatchCenterId=${id}`, {
        withCredentials: true,
        headers: {
            Authorization: `Bearer ${oauth.bearerToken}`,
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            dispatchCenterId: id
        })
    }, false);
}